import React from 'react'
import './Avatar.css'

const Avatar = ({children}) => {
  return (
    <div className='children'>
      {children}
    </div>
  )
}

export default Avatar